import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/trustpilot-stars.png'
import _imports_1 from '../../assets/images/google.png'
import _imports_2 from '../../assets/images/icon-star.png'
import _imports_3 from '../../assets/images/company.png'


const _withScopeId = n => (_pushScopeId("data-v-35cb7057"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title left-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Client Testimonials"),
  /*#__PURE__*/_createElementVNode("h2", { title: "We connect brands with celebrities and influencers for powerful digital campaigns." }, "We help to achieve customers business goals")
], -1))
const _hoisted_6 = { class: "testimonials-single-item" }
const _hoisted_7 = { class: "quality" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex-grow-1 ms-3" }
const _hoisted_12 = { title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" }
const _hoisted_13 = { class: "degeneration" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-controller position-absolute bottom-0 end-0 z-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "controller-icon prev" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-line" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "controller-icon next" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-line" })
  ])
], -1))
const _hoisted_15 = {
  class: "col-lg-5 mt-4 mt-lg-0",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}
const _hoisted_16 = { class: "testimonials-review" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"award-single-item review-on\" data-v-35cb7057><div class=\"d-flex align-items-center mb-1\" data-v-35cb7057><p class=\"review\" data-v-35cb7057>Review On</p><div data-v-35cb7057><img title=\"We connect brands with celebrities and influencers for powerful digital campaigns.\" class=\"trustpilot\" src=\"" + _imports_0 + "\" alt=\"trustpilot-stars\" data-v-35cb7057></div></div><div class=\"d-flex align-items-center\" data-v-35cb7057><img title=\"We connect brands with celebrities and influencers for powerful digital campaigns.\" class=\"review\" src=\"" + _imports_1 + "\" alt=\"trust\" style=\"height:30px;\" data-v-35cb7057><p data-v-35cb7057>100+ Reviews</p></div></div>", 1)
const _hoisted_18 = { class: "award-single-item review-on" }
const _hoisted_19 = { class: "d-flex align-items-center mb-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "review" }, "Review On", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    title: "We connect brands with celebrities and influencers for powerful digital campaigns.",
    class: "review",
    src: _imports_3,
    alt: "company"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "100+ Reviews")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_swiper, {
            spaceBetween: 25,
            slidesPerView: 1,
            preventClicks: true,
            loop: true,
            autoplay: {
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
            navigation: {
              nextEl: '.next',
              prevEl: '.prev',
            },
            modules: _ctx.modules,
            class: "testimonial-slide"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  key: testimonial.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(testimonial.quality), 1),
                      _createElementVNode("p", null, _toDisplayString(testimonial.description), 1),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: testimonial.image,
                            alt: "testimonials"
                          }, null, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("h3", _hoisted_12, _toDisplayString(testimonial.name), 1),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(testimonial.designation), 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _hoisted_14
            ]),
            _: 1
          }, 8, ["modules"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createElementVNode("img", {
                      title: "We connect brands with celebrities and influencers for powerful digital campaigns.",
                      src: _imports_2,
                      alt: "icon-star",
                      key: i
                    })
                  }), 64))
                ])
              ]),
              _hoisted_21
            ])
          ])
        ])
      ])
    ])
  ]))
}